import { Icon } from 'assets/index'
import { useNavigate } from 'react-router-dom'
import { useContext, useEffect } from 'react'
import { UserContext } from 'context/userContext'
import Div from './style'

interface IFeedbackProps {
  feedback: string
}

export default function Feedback(props: any) {
  // const { feedback } = props
  const { setShowModal, feedback } = useContext(UserContext)

  const navigate = useNavigate()

  const redirect = () => {
    setShowModal(false)
    // setTimeout(() => {
    //   navigate('/dashboard', { replace: true })
    // }, 2000)
  }

  useEffect(() => {
    setTimeout(() => redirect(), 3000)
  }, [])
  return (
    <Div error={feedback.current.error}>
      <div className="feedback-container">
        <img className="loading-img" src={Icon('check.svg')} alt="card icon" />
        <span>{feedback.current.title}</span>
      </div>
    </Div>
  )
}
